function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.999,
    height: 32.21,
    viewBox: "0 0 49.998919 32.209892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M24.627.424V8.11H.5V24.1h24.127v7.686l12.554-7.84 12.554-7.84-12.553-7.84L24.628.423z",
    color: "#000",
    overflow: "visible",
    "solid-color": "#000000",
    fill: "none",
    stroke: "red",
    strokeMiterlimit: 1
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e4c8c35f9bfbe9300960f9ca93efb355.svg";
export { ForwardRef as ReactComponent };